import React from "react";

import { useTranslate } from "localization";
import { Filter } from "ui/forms";

import { useReportingYearsQuery } from "API";

import useFilterParam from "./useFilterParam";

const MultiReportingYear: React.FC = () => {
  const { translate } = useTranslate();
  const title = translate("reportingYear");
  const unknown = translate("unknown");

  const {
    data = [],
    isSuccess,
    isError,
  } = useReportingYearsQuery(void 0, {
    selectFromResult: (result) => ({
      ...result,
      data: result.data?.map((item) => ({
        value: item.id,
        label: item.label ?? unknown,
        startDate: item.startDate ?? unknown,
        endDate: item.endDate ?? unknown,
      })),
    }),
  });
  const [selected, setSelected] = useFilterParam("reporting_years", data, {
    defaultToFirst: false,
    multi: true,
    ready: isSuccess || isError,
  });
  return (
    <Filter
      items={{ options: data }}
      title={title}
      label={title}
      selected={!!selected.length}
      count={selected.length ? selected.length : void 0}
      onChange={setSelected}
      disabled={!isSuccess || !selected}
      value={selected}
      multi={true}
      showReset={true}
      showApply={true}
      translate={translate}
    />
  );
};

export default MultiReportingYear;
